import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 z-20 flex items-center justify-center p-4"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "absolute inset-0 bg-black bg-opacity-50" }, null, -1)
const _hoisted_3 = { class: "relative mx-auto z-10 overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:w-2/5 sm:p-6" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: "/img/Icons/Close_Campaign.svg",
  alt: "Close"
}, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h1", { class: "text-dark-blue text-2xl font-roboto text-center mb-3" }, " Share Campaign ", -1)
const _hoisted_7 = { class: "mx-auto flex items-center justify-center space-x-6 rounded-full" }
const _hoisted_8 = ["href"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  src: "/img/Icons/Whatsapp_Campaign.svg",
  alt: "WhatsApp"
}, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = ["href"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  src: "/img/Icons/Email_Campaign.svg",
  alt: "Email"
}, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.instagram.com/",
  target: "_blank"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/img/Icons/Instagram_Campaign.svg",
    alt: "Instagram"
  })
], -1)
const _hoisted_15 = ["href"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("img", {
  src: "/img/Icons/FaceBook_Campaign.svg",
  alt: "Facebook"
}, null, -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = ["href"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("img", {
  src: "/img/Icons/X_Campaign.svg",
  alt: "X"
}, null, -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = {
  key: 0,
  class: "mt-3 text-center sm:mt-5 relative"
}
const _hoisted_22 = {
  key: 0,
  class: "absolute -top-20 right-0 transform translate-y-full bg-dark-blue text-white py-1.5 px-3 rounded-full"
}

import Button from '../AQuarks/Button.vue';
import { watch, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SocialMediaShare',
  props: {
  isVisible: {
    type: Boolean,
    required: true
  }
},
  emits: ['click:isVisible'],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

const sharePath = ref<string>('');
const showTooltip = ref<boolean>(false);
const showEmailInput = ref<boolean>(false);
const emailError = ref<boolean>(false);
const recipientEmail = ref<string>('');

watch(() => props.isVisible, (newVal) => {
  if (newVal) {
    const path = localStorage.getItem('sharePath');
    if (path) {
      sharePath.value = path;
    }
  }
});

const toggleVisibility = () => {
  emit('click:isVisible', !props.isVisible);
  showEmailInput.value = false;
  emailError.value = false;
}

const copyToClipboard = () => {
  navigator.clipboard.writeText(sharePath.value).then(() => {
    showTooltip.value = true;
    setTimeout(() => {
      showTooltip.value = false;
    }, 2000);
  })
}

// FaceBook
const createFacebookLink = () => {
  const urlToShare = encodeURIComponent(sharePath.value);
  const text = encodeURIComponent("Support our campaign and help us reach our goal!");
  
  return `https://www.facebook.com/sharer/sharer.php?u=${urlToShare}&quote=${text}`;
}

// Twitter(X)
const createXShareLink = () => {
  const urlToShare = encodeURIComponent(sharePath.value);
  const text = encodeURIComponent("Support our campaign and help us reach our goal!");
  
  return `https://twitter.com/intent/tweet?url=${urlToShare}&text=${text}`;
}

// WhatsApp
const createWhatsAppLink = () => {
  const urlToShare = encodeURIComponent(sharePath.value);
  const message = `Hi,%0APlease support our campaign and help us reach our goal!:%0A${urlToShare}`;
  
  return `https://wa.me/?text=${message}`;
}

// Email
const emailShare = () => {
  const subject = encodeURIComponent('Support our campaign and help us reach our goal!');
  const body = encodeURIComponent(`Hi,\n\nPlease support our campaign by visiting this link: ${sharePath.value}\n\nThank you!`);

  return `mailto:${recipientEmail.value}?subject=${subject}&body=${body}`;
}

return (_ctx: any,_cache: any) => {
  return (__props.isVisible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            onClick: toggleVisibility,
            class: "absolute top-0 right-0 m-4"
          }, _hoisted_5),
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("a", {
              href: createWhatsAppLink(),
              target: "_blank"
            }, _hoisted_10, 8, _hoisted_8),
            _createElementVNode("a", {
              href: emailShare(),
              target: "_blank"
            }, _hoisted_13, 8, _hoisted_11),
            _hoisted_14,
            _createElementVNode("a", {
              href: createFacebookLink(),
              target: "_blank"
            }, _hoisted_17, 8, _hoisted_15),
            _createElementVNode("a", {
              href: createXShareLink(),
              target: "_blank"
            }, _hoisted_20, 8, _hoisted_18)
          ]),
          (!showEmailInput.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((sharePath).value = $event)),
                  class: "border border-gray-300 rounded-full py-2 pl-4 pr-10 outline-none shadow-sm w-full"
                }, null, 512), [
                  [_vModelText, sharePath.value]
                ]),
                (showTooltip.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, " Copied! "))
                  : _createCommentVNode("", true),
                _createVNode(Button, {
                  buttonText: "Copy",
                  onClick: copyToClipboard,
                  class: "absolute inset-y-0 right-0 flex items-center px-5 rounded-r-full bg-dark-blue text-white"
                })
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})